var React = require('react');

function IconAddToList (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},[React.createElement("path",{"d":"M8.256 2c-.112.318-.19.653-.229 1H.5a.5.5 0 0 1 0-1h7.756zM8.758 6c.253.378.561.715.913 1H.5a.5.5 0 0 1 0-1h8.258z","key":0}),React.createElement("rect",{"y":"10","width":"12","height":"1","rx":".5","key":1}),React.createElement("path",{"d":"M12 4h-2a.5.5 0 0 1 0-1h2V1a.5.5 0 0 1 1 0v2h2a.5.5 0 0 1 0 1h-2v2a.5.5 0 0 1-1 0V4z","fillRule":"nonzero","key":2})]));
}

IconAddToList.defaultProps = {"width":"16","height":"11"};

module.exports = IconAddToList;

IconAddToList.default = IconAddToList;
